import { Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { useDialog } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { PaymentMethodDialog } from "./PaymentMethodDialog";
import { PaymentMethodDto } from "./types";


export function PaymentMethodListPage() {
    const [usePaymentMethodsStore] = useState(() => createListStore<PaymentMethodDto>({
        path: "settings/paymentMethods",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "id", label: "Id", width: 120 },
            { column: "code", label: "Code", width: 120 },
            { column: "description", label: "Description", width: 300 },
            { column: "active", label: "Active", width: 120, type: "bool" },
        ],
    }));

    const paymentMethods = usePaymentMethodsStore(p => ({ selectedItem: p.selectedItem }));
    const editDialog = useDialog(close => <PaymentMethodDialog close={close} paymentMethod={paymentMethods.selectedItem!}
        onChange={() => { usePaymentMethodsStore.getState().fetch(); }} />, "xs");
    return <>
        {editDialog.render()}
        <PageTitle title="Payment methods" />
        {renderListStore(usePaymentMethodsStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={paymentMethods.selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
            ]),
        })}
    </>;
}
